import { useContext, useMemo, useState, useEffect, cloneElement } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Context_UI } from "../../Contexts/Context_UI";
import { useStatus } from "../../Contexts/Context_Status_Global";


export default function UI_Subwindow_Manager({ Composition }) {
    const UI = useContext(Context_UI);
    const navigate = useNavigate();
    
    const [Active, Active_Set] = useState([]);
    const [Current, Current_Set] = useState(null);

    useEffect(() => {
        const Handle_Open = ({ ID, ReturnPath }) => {
            Active_Set(Previous => {
                if (Previous.find(Item => Item.ID === ID)) {
                    Current_Set(ID);
                    return Previous;
                }
                const Updated = [...Previous, { ID, ReturnPath }];
                Current_Set(ID);
                return Updated;
            });
        };

        const Handle_Close = ({ ID }) => {
            Active_Set(Previous => {
                const Closing = Previous.find(Item => Item.ID === ID);
                const Updated = Previous.filter(Item => Item.ID !== ID);

                Current_Set(Updated[Updated.length - 1]?.ID || null);

                if (Closing?.ReturnPath) {
                    navigate(Closing.ReturnPath);
                }

                return Updated;
            });
        };

        UI.on("Subwindow_Request_Open", Handle_Open);
        UI.on("Subwindow_Request_Close", Handle_Close);

        return () => {
            UI.off("Subwindow_Request_Open", Handle_Open);
            UI.off("Subwindow_Request_Close", Handle_Close);
        }
    }, [UI]);

    return (
        <ui-subwindows id="Subwindows" State={Active.length > 0 ? "Active" : "Inactive"}>
            {Composition.map(({ ID, Component }) => {
                const ActiveItem = Active.find(Item => Item.ID === ID);
                if (!ActiveItem) return null;

                return cloneElement(Component, {
                    key: ID,
                    id: ID,
                    zIndex: Active.indexOf(ActiveItem) + 1,
                    isActive: Current === ID,
                    inert: Current === ID ? "" : undefined,
                });
            })}

        </ui-subwindows>
        
    )
}

